export default "__VITE_ASSET__BB_PdZT1__"